
















import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';
import GEFormFields from '@/Types/GEFormFields';
import {SchemaFieldIfCallback} from '@/Types/SchemaField';

@Component({})
export default class YesNoNaInput extends Vue {
    static COMPONENT_NAME = 'yes-no-na-input'

    static YES = 'yes'
    static NO = 'no'
    static NA = 'na'

    static isYes(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoNaInput.YES
    }

    static isNo(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoNaInput.NO
    }

    static isNa(fieldName: string): SchemaFieldIfCallback {
        return (fields: GEFormFields) => fields[fieldName] === YesNoNaInput.NA
    }

    @Prop({type: Object, default: () => {}}) options!: Record<string, string>

    get appendedOptions(): Record<string, string> {
        const opts = {
            [YesNoNaInput.YES]: 'Yes',
            [YesNoNaInput.NO]: 'No',
            [YesNoNaInput.NA]: 'N/A',
        }

        return {
            ...opts,
            ...this.$props.options
        }
    }
}
